import React from "react"
import { Hidden } from "@material-ui/core"

import CallToAction from "./CallToAction"
import WideCallToAction from "./WideCallToAction"

const DynamicCallToAction = () => {
  return (
    <>
      <Hidden xlUp>
        <CallToAction />
      </Hidden>
      <Hidden lgDown>
        <WideCallToAction />
      </Hidden>
    </>
  )
}

export default DynamicCallToAction
